import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
const PromptBox = ({
  show,
  handleClosePrompt,
  title,
  message,
  handleClose,
  handleSave,
  isLoading,
}) => {
  const [translation] = useTranslation("translations");
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-danger" onClick={handleClosePrompt}>
          {isLoading ? (
            <Spinner animation="border" size="sm" style={{ color: "#fff" }} />
          ) : (
            <>{translation("buttons.leave")}</>
          )}
        </Button>
        <button type="button" onClick={handleSave} className="btn btn-halite-blue-light">
          {isLoading ? (
            <Spinner animation="border" size="sm" style={{ color: "#fff" }} />
          ) : (
            <>{translation("buttons.save")}</>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};
export default PromptBox;

